import { Controller } from "@hotwired/stimulus"

// Marks a notification read client-side when it is clicked. The notification
// row is a link to its action_url, so the POST uses keepalive to survive the
// navigation that follows. The row also updates optimistically (drop the
// unread tint + dot) for instant feedback before any reload.
//
// Fixes the audit's dead `notifications#markRead` reference: the action was
// wired in the view but no controller was ever registered.
export default class extends Controller {
  static values = { url: String }

  markRead() {
    if (!this.urlValue) return

    const token = document.querySelector("meta[name='csrf-token']")?.content
    fetch(this.urlValue, {
      method: "POST",
      keepalive: true,
      headers: {
        "X-CSRF-Token": token || "",
        "Accept": "application/json"
      }
    }).catch(() => {})

    // Optimistic UI: clear the unread styling immediately.
    this.element.classList.remove("bg-[#C4A484]/5")
    this.element.querySelectorAll(".font-semibold").forEach((el) => el.classList.remove("font-semibold"))
    this.element.querySelectorAll(".bg-[\\#C4A484]").forEach((dot) => dot.remove())
  }
}
